export default __webpack_public_path__ + "static/media/QB-Icon.0e741faf.svg";